$('.quantity .plus').on('click',function(e){
  var val = parseInt($(this).closest('.quantity').find('.input-text.qty').val());
  var max = parseInt($(this).closest('.quantity').find('.input-text.qty').attr('max'));
  val += 1;
  $(this).closest('.tab_pd_item').addClass('active')
  if(val <= max){
   $(this).closest('.quantity').find('.input-text.qty').val(val);
	$(this).closest('.tab_pd_item').find('.pd_count').text(val);
    $(this).closest('.tab_pd_item').find('.pd_count').show();
  }else{
   $(this).closest('.quantity').find('.input-text.qty').val(max);
    $(this).closest('.tab_pd_item').find('.pd_count').text(max);
    $(this).closest('.tab_pd_item').find('.pd_count').show();
  }
  var _count = 0;
  var _price = 0;
     $('.image_price .selected_images').html('');
  $('.kit_tabs .tab-content .tab_pd_item.active').each(function(e){
    _count += parseInt($(this).find('.pd_count').text());
    _price += parseInt($(this).data('price'))*_count;
    var img = $(this).data('img');
    $('.image_price .selected_images').append('<img src="'+img+'">');
  })

  $('.total_product').text(_count);

  $('.all_cart_total .total_price').text(Shopify.formatMoney(_price, window.money_format));
})

$('.quantity .minus').on('click',function(e){
  var val = parseInt($(this).closest('.quantity').find('.input-text.qty').val());
  var min = 0;
  val -= 1;
  if(val > min){
   $(this).closest('.quantity').find('.input-text.qty').val(val);
	$(this).closest('.tab_pd_item').find('.pd_count').text(val);
    $(this).closest('.tab_pd_item').find('.pd_count').show();
     $(this).closest('.tab_pd_item').addClass('active')
  }else{
   $(this).closest('.quantity').find('.input-text.qty').val(min);
    $(this).closest('.tab_pd_item').find('.pd_count').text(min);
    $(this).closest('.tab_pd_item').find('.pd_count').hide();
	 $(this).closest('.tab_pd_item').removeClass('active')
  }
  
  var _count = 0;
  var _price = 0;
   $('.image_price .selected_images').html('');
  $('.kit_tabs .tab-content .tab_pd_item.active').each(function(e){
    _count += parseInt($(this).find('.pd_count').text());
	_price += parseInt($(this).data('price'))*_count;
    var img = $(this).data('img');
    $('.image_price .selected_images').append('<img src="'+img+'">');
  })

  $('.total_product').text(_count);
  
  $('.all_cart_total .total_price').text(Shopify.formatMoney(_price, window.money_format));
  
})


$(document).on('click','.delivery_wrapper .ctm_btn',function(e){
  var val = parseInt($(this).closest('.delivery_wrapper').find('.ctm_check').val());
  var splt_val = ($(this).closest('.delivery_option_check').data('location')).split(',');
  var count = 0;
  for(var i = 0; i < splt_val.length; i++){
    var compare_val = parseInt(splt_val[i]);
    if(compare_val == val){
      count++;
    }
  }

  if(count != 0){
    $('.groups-btn .ctm_disabled').removeClass('ctm_disabled');
    $('.product_top .shopify-product-form .quantity').removeClass('ctm_disabled');
    $('.product_top .shopify-product-form .total-price').removeClass('ctm_disabled');
    $(this).closest('.delivery_option_check').find('.ctm_err').hide();
    $(this).closest('.delivery_option_check').find('.ctm_success').show();
  }else{
    $('.groups-btn .groups-btn-tree,.groups-btn .checkbox-group,.groups-btn .btn-checkout').addClass('ctm_disabled');
    $(this).closest('.product_top').find('.shopify-product-form .quantity').addClass('ctm_disabled');
    $(this).closest('.product_top').find('.shopify-product-form .total-price').addClass('ctm_disabled');
    $(this).closest('.delivery_option_check').find('.ctm_success').hide();
    $(this).closest('.delivery_option_check').find('.ctm_err').show();

  }
});

$(document).on('keypress','.delivery_option_check .delivery_wrapper .ctm_check',function(e){
  if ( e.which == 13 ){
//     $(this).closest('.delivery_option_check').find('.err_msg').show();
    $(this).closest('.delivery_option_check').find('.ctm_btn').trigger('click');
    return false;
  }
  if ( e.which == 13 ) e.preventDefault();
})

$('.btn_step:not(.submit_btn)').on('click',function(e){
  var _val = $(this).closest('.step_rpt_title').find('select.ctm_selector').val();
  console.log(_val);
  if(_val != '' && _val != null){
    $(this).closest('.step_repeat').addClass('ctm_active');
    $(this).closest('.step_repeat').next('.step_repeat').removeClass('ctm_sec_disabled');
    
    $(this).closest('.step_repeat').addClass('active_section');
    var sec = $(this).closest('.step_repeat').next('.step_repeat');
    $('html,body').animate({
      scrollTop: sec.offset().top - 40
    },'slow');
  }
})
// $('select.ctm_selector').on('change',function(e){
//   var _val = $(this).val();
//   console.log(_val,$(this).closest('.selector-wrapper'));
//   $(this).closest('.selector-wrapper').find('.current_class').removeClass('current_class');
//   $(this).closest('.step_repeat').addClass('current_class');
//   var count = 0;
//   $(this).closest('.selector-wrapper').find('.step_repeat').each(function(e){
//     if(count == 0){
//       if($(this).closest('.step_repeat').hasClass('current_class')){
//         count=999;
//         console.log('demo 123 456',count)
//       }
//     }else{
//       console.log('working')
//       $(this).closest('.step_repeat').addClass('ctm_sec_disabled')
//     }
//   });
//   var len = $(this).closest('.selector-wrapper').find('.step_repeat.ctm_active').length;
//   console.log(len);
// })

$(document).on('click','.subs_tab_list .nav-tabs li',function(e){
  var tag = $(this).find('a').attr('href');
  $('.subs_tab_list .tab-content .tab-pane').removeClass('active');
  $('.subs_tab_list .tab-content .tab-pane').removeClass('show');
  $('.subs_tab_list .tab-content').find(tag).addClass('active');
  $('.subs_tab_list .tab-content').find(tag).addClass('show');
  $('.selector-wrapper').hide();
})
$(document).on('click','.subs_tabs_item .subs_btn',function(){
    var datachoose = $(this).data('hand');
    $('.product-form__item').each(function(){
        var match = $(this).data('index');
        if(datachoose == match){
            $(this).css('display','block');
        }else{
            $(this).css('display','none');
        }
    })
    $(this).closest('.tab-content').find('.subs_tabs_item').removeClass('ctm_active');
    $(this).closest('.subs_tabs_item').addClass('ctm_active');
});
$('.selector-wrapper .step_gift_own select').on('change',function(e) {
  var optionValue = jQuery(this).val();
  var prop = 'properties['+optionValue+']';
//   $(this).closest('.selector-wrapper').find('form .pro_gift').attr('name', prop);
  $(this).closest('form').find('.pro_gift').attr('value', optionValue);
});
$('.selector-wrapper .step_flower_delivere select').on('change',function(e) {
  var optionValue = jQuery(this).val();
  var prop = 'properties['+optionValue+']';
//   $(this).closest('.selector-wrapper').find('form .pro_delivere').attr('name', prop);
  $(this).closest('form').find('.pro_delivere').attr('value', optionValue);
});
$('.selector-wrapper .step_for_period select').on('change',function(e) {
  var optionValue = jQuery(this).val();
  var prop = 'properties['+optionValue+']';
//   $(this).closest('.selector-wrapper').find('form .pro_period').attr('name', prop);
  $(this).closest('form').find('.pro_period').attr('value', optionValue);
});
$('.selector-wrapper .step_repeat_opt .product-form__input').on('change',function(e) {
  var optionValue = jQuery(this).val();
  var final_val;
  $(this).closest('.selector-wrapper').find('.single-option-selector').each(function(i,e){
    if(i == 0){
      final_val = $(this).val();
    }else{
      final_val = final_val+' / '+$(this).val();
    }
  });
  var lenthopt = $(this).closest('.selector-wrapper').find('.step_repeat_opt').length;
  console.log(final_val,lenthopt);
  if(lenthopt > 1){	
    console.log('demo 12345798', $(this).closest('form'),'working');
    $(this).closest('form').find('[name="id"] option').each(function(i,e){
      var text = $(this).data('title').trim();
      if(text == final_val){
        var data_qty = $(this).data('qty');
        console.log(data_qty);
        $(this).closest('select').val($(this).val()).trigger('change'); 
        var updateprice = $(this).data('price');
        $(this).closest('.subs_total').find('.step_total_table').find('.subtotal_price').text(updateprice);
        $(this).closest('.subs_total').find('.step_total_table').find('.final_totle').text(updateprice);  
        if(data_qty != 0){
          $(this).closest('.subs_total').find('.step_total_table .submit_btn').text('Add to Cart');  
          $(this).closest('.subs_total').find('.step_total_table .submit_btn').removeAttr('disabled');  
        }else{
          $(this).closest('.subs_total').find('.step_total_table .submit_btn').text('Sold out');  
          $(this).closest('.subs_total').find('.step_total_table .submit_btn').attr('disabled',true);  
        }
        return false;
      }
    });
  }else{
    $(this).closest('form').find('[name="id"] option').each(function(i,e){
      var text = $(this).data('title');
       if(text == final_val){
        var data_qty = $(this).data('qty');
        $(this).closest('select').val($(this).val()).trigger('change');  
        var updateprice = $(this).data('price');
        $(this).closest('.subs_total').find('.step_total_table').find('.subtotal_price').text(updateprice);
         $(this).closest('.subs_total').find('.step_total_table').find('.final_totle').text(updateprice);
         if(data_qty != 0){
           $(this).closest('.subs_total').find('.step_total_table .submit_btn').text('Add to Cart');  
           $(this).closest('.subs_total').find('.step_total_table .submit_btn').removeAttr('disabled');  
         }else{
           $(this).closest('.subs_total').find('.step_total_table .submit_btn').text('Sold out');  
           $(this).closest('.subs_total').find('.step_total_table .submit_btn').attr('disabled',true);  
         }
        return false;
      }
    });
  }
});

$(document).on('change','.swatch_wrap_chnages input',function(){
  var sel = $(this).data('vid');
  $('.swatch .'+sel).find('input').click();
  setTimeout(function(e){
	var val = $('select#product-selectors').val();
    console.log(val);
    $('select#product-selectors option').each(function(e){
      var _val = $(this).val();
      if(_val == val){ 
        var price = $(this).data('price');
        var qty = parseInt($('#data_quantity').val());
        $('.price_range .range_start').text(Shopify.formatMoney((price*qty), window.money_format));
        $('.price_range .range_end').text(Shopify.formatMoney((price*20), window.money_format));
        $('#data_quantity').attr('data-price',price);
        
        var _main_count = 1
        $('.option_swatchs .ctm_size .option_value :radio').each(function(e){
          if($(this).prop('checked')){
            _main_count = $(this).data('vid');
          }
        })
        var total_price = price*qty;
        var _price = total_price / _main_count;
        console.log(total_price,_price);
        $('input[name="properties[Number of arrangements selected]"]').val(_main_count);
        $('input[name="properties[Price per arrangement]"]').val(Shopify.formatMoney(_price, window.money_format));
        $('.ctm_selection_div .no_of_count .count').text(_main_count);
        $('.ctm_selection_div .no_of_price .ctm_price').text(Shopify.formatMoney(_price, window.money_format));
      }
    })
  },50)
})

$('.option_swatchs select.select_drop_down').on('change',function(e){
  var val = $(this).val();
  $(this).closest('.option_swatchs').find(':radio').each(function(e){
    var _val = $(this).data('vid');
    if(_val == val){
      $(this).next('label').trigger('click');
    }
  })
})

$('.price_range #price_val').on('change input',function(e){
  range_price();
})
function range_price(){
  var redVal=parseInt(document.getElementById('price_val').value)
  document.getElementById("data_quantity").value  = redVal; 
  var price = $('#data_quantity').attr('data-price');
  var total_price =  redVal * price;
  
  var _main_count = 1
  $('.option_swatchs .ctm_size .option_value :radio').each(function(e){
    if($(this).prop('checked')){
      _main_count = $(this).data('vid');
    }
  })
  var _price = total_price / _main_count;
  console.log(total_price,_price);
  $('input[name="properties[Number of arrangements selected]"]').val(_main_count);
  $('input[name="properties[Price per arrangement]"]').val(Shopify.formatMoney(_price, window.money_format));
  $('.ctm_selection_div .no_of_count .count').text(_main_count);
  $('.ctm_selection_div .no_of_price .ctm_price').text(Shopify.formatMoney(_price, window.money_format));
  $('.price_range .range_start').text(Shopify.formatMoney(total_price, window.money_format));
}

$(document).ready(function(){
  var codate = $.cookie('date_cookie');
  if(codate == undefined){
    $('.datepicker').val('');
  }else{
    $('.datepicker').val(codate);
  }
    var dateinput = $('.wrapper-cart-template .datepicker').val();
    if($('.wrapper-cart-template .datepicker').length > 0){
//       $('.cart-form .btn-actions .btn-checkout').removeClass("disabled_check");
    }
});

$(document).on('change','.datepicker',function(){
  var chnagedate = $(this).val();
//   $('.cart-form .btn-actions .btn-checkout').removeClass("disabled_check");
  $('.err_checkout_msg').hide();    
  $.cookie('date_cookie',chnagedate,{expire:30,path:'/'});
});

$('.ctm_checkout_btn').on('click',function(e){
  var val = $('.datepicker').val();
  var phone = $('input[name="attributes[Phone Number]"]').val();
  var phonePattern = /^[0-9]{10}$/;
  if(val != '' && val != undefined && phonePattern.test(phone)){
     var _this = $(this); 
     var note = $('.cart-form.wrapper-cart-template [name="note"]').val();
      $.ajax({
        method: "post",
        url: "/cart/update.js",
        data:{
            note: note,
            attributes: {
    "Phone Number": phone
  }
        },
        dataType: "json",
        success: function(data) {
          console.log(data)
          _this.closest('.btn-actions').find('.checkout_trigger')[0].click();
        },
        error: function(err) {
          console.log(err)
          _this.closest('.btn-actions').find('.checkout_trigger')[0].click();
        }
      })
 }else{

  if((val == '' || val == undefined) && (phone == '' || phone == undefined)){
    $('.err_checkout_msg').text('Please select delivery date and enter phone number');
  }

  else if(val == '' || val == undefined){
    $('.err_checkout_msg').text("Delivery date can't be empty");
  }

 else if(phone == '' || phone == undefined){
  $('.err_checkout_msg').text("Phone number can't be empty");
}
else if(!phonePattern.test(phone)){
  $('.err_checkout_msg').text("Please enter a valid 10 digit phone number");
}

  $('.err_checkout_msg').show();

  setTimeout(function(){
    $('.err_checkout_msg').hide();
  },4000)

}
})
